import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BreadcrumbService } from './breadcrumb.service';
import { AuthStorageService } from './auth-storage.service';
import { LocalStorageService } from './local-storage.service';
import { AuthService } from './auth.service';
import { MessageService } from './message.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthServicesModule } from '../modules/auth/services/services.module';

@NgModule({
  imports: [
    HttpClientModule,
    MatDialogModule,
    MatSnackBarModule,
    AuthServicesModule
  ],
  providers: [
    BreadcrumbService,
    AuthService,
    AuthStorageService,
    LocalStorageService,
    MessageService
  ]
})
export class ServicesModule { }
